import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../Button/Button';
import Spinner from '../Spinner/Spinner';
import classes from './Confirm.css';
import Box from '../../../hoc/Box/Box';
import axios from '../../../axios-local-api';
import Input from '../Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
import {
  updateObject,
  checkValidity
} from '../../../shared/utility';

class SpecReadyConfirm extends Component {
  state = {    
    formIsValid: false
  }

  render() {
    // console.log('SPEC PROPS', this.props)
    let form = (
            <div className={this.props.deviceGroupConfirmation ? classes.DeviceGroupButtonRow : classes.ButtonRow}>
                <button 
                id= 'ModalCancelButton'
                className={ this.props.deviceGroupConfirmation ? classes.CancelButton : classes.RegularButton}
                onClick ={this.props.cancel}
                >
                  {'Cancel'}
                </button>

                <button 
                id='ModalOkButton'
                visibility = 'true' 
                className={this.props.deviceGroupConfirmation ? classes.ConfirmButton :  classes.RegularButton}
                onClick ={this.props.confirm}
                >
                  {'Yes'}
                </button>

                
            </div>
    );
    if (this.props.loading) {
      form = <Spinner />;
    }
    let message;
    if(this.props.toggleOn){
      message = (
        <div className={classes.Confirm}>
        <div className={classes.HeaderRow}>
        <h4 style={{ textAlign:'center' }}>Confirmation of WiFi Router Ports?</h4>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ textAlign:'center' }}>Router will allow internet connectivity.</ span>
        <span style={{ textAlign:'center' }}>Please ensure billing account is enabled.</ span>
        <span style={{ textAlign:'center' }}>Are you sure you want to proceed?</ span>
        </div>
        
        {form}
      </div>
      )
    } else {
      message = (
        <div className={classes.Confirm}>
        <div className={classes.HeaderRow}>
        <h4 style={{ textAlign:'center' }}>Deactivate WiFi and Router Ports?</h4>
        </div >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ textAlign:'center' }}>Router will be factory Reset, WiFi and Router ports will be immediately disabled, and all configurations will be erased.</ span>
        <span style={{ textAlign:'center' }}>Are you sure you want to proceed?</span>
        </div>
        
        
        {form}
    </div>
      )
    }
  
    return (
      <div>
     {message}
     </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  }
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(SpecReadyConfirm, axios));
